"use client";

import { c as _c } from "react/compiler-runtime";
import { HeroHeaderSkeleton } from "@/components/hero-header/HeroHeaderSkeleton";
import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider";
import { CollectionHeaderCompactContentSkeleton, CollectionHeaderFullContentSkeleton } from "./CollectionHeaderContentSkeleton";
export function CollectionHeaderSkeleton() {
  const $ = _c(4);
  const {
    headerView
  } = useHeroHeaderView();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CollectionHeaderCompactContentSkeleton />;
    t1 = <CollectionHeaderFullContentSkeleton />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== headerView) {
    t2 = <HeroHeaderSkeleton compactContent={t0} fullContent={t1} headerView={headerView} isCollectionBanner={true} />;
    $[2] = headerView;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}